import { Injectable } from '@angular/core';
import { Observable, catchError, from, map, of, switchMap, throwError } from 'rxjs';
import { environment } from '@examdojo/core/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ToastService } from '@examdojo/core/toast';

@Injectable()
export class QuestionImageGenerationService {
  constructor(
    private readonly http: HttpClient,
    private readonly toastService: ToastService,
  ) {}

  generateImage(code: string): Observable<File | null> {
    return this.http
      .post(
        `${environment.examdojo.examdojoApiUrl}/review/image-from-code`,
        {
          python_code: code,
        },
        {
          responseType: 'blob',
        },
      )
      .pipe(
        map((blob) => {
          return new File([blob], '', {
            type: 'image/png',
          });
        }),

        catchError((error: unknown) => {
          if (error instanceof HttpErrorResponse && error.error instanceof Blob) {
            return from(error.error.text()).pipe(
              switchMap((errorMessage) => {
                const parsedError = typeof errorMessage === 'string' ? JSON.parse(errorMessage) : errorMessage;
                if (
                  parsedError &&
                  typeof parsedError === 'object' &&
                  'error_code' in parsedError &&
                  'error_message' in parsedError
                ) {
                  this.toastService.error(parsedError.error_message);
                  return of(null);
                }
                return throwError(() => parsedError);
              }),
            );
          }

          throw error;
        }),
      );
  }
}
